import Immutable from "immutable";

export class ModalState extends Immutable.Record({
  isOpen: false,
  view: null,
  modalProps: Immutable.Map({})
}) {}

export const modal = (state = new ModalState(), action) => {
  switch (action.type) {
    case "SET_MODAL": {
      let newState = state.merge(action.payload);
      const modalProps = Immutable.Map(action.payload.modalProps);
      // need this because Map.merge converts everything to immutable objects deeply
      // which is not what we want for the modalProps, they should remain unmodified.
      // this is fixed in the latest version of ImmutableJS 4.0.0-rc.12
      newState = newState.set("modalProps", modalProps);

      return newState;
    }

    case "CLOSE_MODAL":
      return state.merge({
        isOpen: false
      });
    case "CREATE_RESPONSE_SUCCESS":
      return state.merge({
        isOpen: false,
        view: null,
        modalProps: {}
      });
    case "CLEAR_MODAL":
      return state.merge({
        view: null,
        modalProps: {}
      });
    default:
      return state;
  }
};
